import { useCartStore } from '../store/cartStore'
import { useNavigate, Link } from 'react-router-dom'
import OptimizedImage from '../components/OptimizedImage'

const CartPage = () => {
  const navigate = useNavigate()
  const items = useCartStore((state) => state.items)
  const updateQuantity = useCartStore((state) => state.updateQuantity)
  const removeItem = useCartStore((state) => state.removeItem)
  const getTotalPrice = useCartStore((state) => state.getTotalPrice)
  const cartItemsCount = useCartStore((state) => state.getTotalItems())

  const formatPrice = (value) => {
    return new Intl.NumberFormat('ru-RU').format(value)
  }

  if (items.length === 0) {
    return (
      <div style={styles.page}>
        <div style={styles.header}>
          <button onClick={() => navigate(-1)} style={styles.backArrowBtn} aria-label="Back">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
          <Link to="/cart" style={styles.cartLink} aria-label="Cart">
            {cartItemsCount > 0 && (
              <span style={styles.cartCount}>{cartItemsCount}</span>
            )}
            <div style={styles.cartIcon}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="5" y="11" width="14" height="10" rx="1" />
                <path d="M8 11V8a4 4 0 1 1 8 0v3" />
              </svg>
            </div>
          </Link>
        </div>
        <div className="empty-state" style={{ marginTop: '52px' }}>
          <h2>Корзина пуста</h2>
          <p>Добавьте товары из каталога</p>
          <button 
            onClick={() => navigate('/')} 
            className="add-to-cart-btn"
            style={{ maxWidth: '200px', marginTop: 'var(--sp-4)' }}
          >
            В каталог
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backArrowBtn} aria-label="Back">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
        </button>
        <Link to="/cart" style={styles.cartLink} aria-label="Cart">
          {cartItemsCount > 0 && (
            <span style={styles.cartCount}>{cartItemsCount}</span>
          )}
          <div style={styles.cartIcon}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="5" y="11" width="14" height="10" rx="1" />
              <path d="M8 11V8a4 4 0 1 1 8 0v3" />
            </svg>
          </div>
        </Link>
      </div>
      <div className="cart-page fade-in" style={{ marginTop: '52px' }}>
      <h1 style={{ 
        fontSize: '0.75rem', 
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
        marginBottom: 'var(--sp-6)',
        textAlign: 'center'
      }}>
        Корзина
      </h1>
      
      <div className="cart-items">
        {items.map((item, index) => (
          <div 
            key={item.id} 
            className="cart-item"
            style={{ animationDelay: `${index * 50}ms` }}
          >
            <OptimizedImage
              src={item.productImage}
              alt={item.productName}
              className="cart-item-image"
              sizes="80px"
              aspectRatio="1/1"
              objectFit="cover"
              placeholder={false}
            />
            <div className="cart-item-info">
              <div className="cart-item-name">{item.productName}</div>
              {(item.variantSize || item.variantColor) && (
                <div className="cart-item-variant">
                  {item.variantSize && `${item.variantSize}`}
                  {item.variantSize && item.variantColor && ' / '}
                  {item.variantColor && `${item.variantColor}`}
                </div>
              )}
              <div className="cart-item-price">{formatPrice(item.price)} ₽</div>
              
              <div className="cart-item-actions">
                <div className="quantity-controls">
                  <button
                    className="quantity-btn"
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                    aria-label="Уменьшить количество"
                  >
                    −
                  </button>
                  <input
                    type="number"
                    className="quantity-input"
                    value={item.quantity}
                    onChange={(e) => {
                      const qty = parseInt(e.target.value) || 1
                      updateQuantity(item.id, qty)
                    }}
                    min="1"
                    aria-label="Количество"
                  />
                  <button
                    className="quantity-btn"
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                    aria-label="Увеличить количество"
                  >
                    +
                  </button>
                </div>
                <button
                  className="remove-btn"
                  onClick={() => removeItem(item.id)}
                >
                  Удалить
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="cart-summary">
        <div className="cart-total">
          <span>Итого</span>
          <span>{formatPrice(getTotalPrice())} ₽</span>
        </div>
        <button 
          className="checkout-btn" 
          onClick={() => navigate('/checkout')}
        >
          Оформить заказ
        </button>
      </div>
      </div>
    </div>
  )
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#fff',
  },
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '52px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 16px',
    background: '#fff',
    zIndex: 100,
  },
  backArrowBtn: {
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    color: '#000',
  },
  cartLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    textDecoration: 'none',
    color: '#000',
  },
  cartCount: {
    fontSize: '12px',
    fontWeight: '500',
    color: '#000',
  },
  cartIcon: {
    width: '18px',
    height: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

export default CartPage
